import { useEffect, useState } from 'react';
import { Modal } from '../../../../components/ui/Modal/Modal';
import { Button } from '../../../../components/ui/Button/Button';
import styles from './SkipEnquiryCancelModal.module.css';

export interface SkipEnquiryCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  enquiryReference: string;
  onConfirm: (reason: string) => void;
  isLoading: boolean;
  errorMessage?: string | null;
}

const MIN_REASON = 10;

export function SkipEnquiryCancelModal({
  isOpen,
  onClose,
  enquiryReference,
  onConfirm,
  isLoading,
  errorMessage,
}: SkipEnquiryCancelModalProps): JSX.Element {
  const [reason, setReason] = useState('');
  const [validation, setValidation] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) {
      setReason('');
      setValidation(null);
    }
  }, [isOpen]);

  function handleConfirm() {
    const trimmed = reason.trim();
    if (trimmed.length < MIN_REASON) {
      setValidation(`Please give a reason of at least ${MIN_REASON} characters.`);
      return;
    }
    setValidation(null);
    onConfirm(trimmed);
  }

  return (
    <Modal
      open={isOpen}
      onClose={isLoading ? () => undefined : onClose}
      title="Cancel Enquiry"
      size="sm"
      footer={
        <div className={styles.footer}>
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Keep Enquiry
          </Button>
          <Button variant="danger" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? 'Cancelling…' : 'Cancel Enquiry'}
          </Button>
        </div>
      }
    >
      <p className={styles.body}>
        Cancel enquiry <strong>{enquiryReference}</strong>? This cannot be undone.
      </p>
      <label className={styles.field}>
        <span>Reason</span>
        <textarea
          rows={3}
          maxLength={2000}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Why is this enquiry being cancelled?"
        />
      </label>
      {validation ? <p className={styles.error}>{validation}</p> : null}
      {errorMessage ? <p className={styles.error}>{errorMessage}</p> : null}
    </Modal>
  );
}
